import React from "react";
import { useTranslation } from "react-i18next";
import { PASSWORD_RULES, STRENGTH, passwordScore } from "../../config/password";
import "../../pages/landing/ln.scss";

// Parol xavfsizligi indikatori va talablar ro'yxati (ro'yxatdan o'tish, parolni almashtirish)
export default function PasswordMeter({ value = "" }) {
  const { t } = useTranslation();
  const score = passwordScore(value);
  const strength = STRENGTH[score];
  return (
    <div className="ln-pwmeter">
      <div className="ln-pwmeter__head">
        <span>{t("pw_strength")}</span>
        <strong style={{ color: value ? strength.color : undefined }}>{value ? t(strength.key) : "—"}</strong>
      </div>
      <div className="ln-pwmeter__bar">
        {[1, 2, 3, 4].map((n) => (
          <span key={n} style={{ background: value && n <= score ? strength.color : undefined }} />
        ))}
      </div>
      <ul className="ln-pwmeter__rules">
        {PASSWORD_RULES.map((r) => {
          const ok = r.test(value);
          return (
            <li key={r.key} className={ok ? "is-ok" : ""}>
              {ok ? (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10" /></svg>
              ) : (
                <span className="ln-pwmeter__dot" />
              )}
              {t(r.key)}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
